var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 76,
    viewBox: "0 0 99 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.9112 69.5749C71.558 71.5177 65.5782 72.5224 57.9716 72.5888C50.5268 72.6538 43.3937 71.3349 36.5721 68.6325C29.9126 65.9286 24.2168 62.4068 19.4851 58.0672C9.53465 49.2015 4.50975 39.1023 4.41085 27.7697C4.31527 16.8178 9.02185 9.01468 18.531 4.36018C23.8503 1.83758 30.1512 0.544475 37.434 0.480875C51.8382 0.355175 64.6616 4.57668 75.9044 13.1454C87.1472 21.7141 92.8209 31.9981 92.9257 43.9975C93.0312 56.0921 87.3597 64.6177 75.9112 69.5749Z",
    fill: "#FFC8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7192 0.924656C31.9354 -0.0108443 33.5471 -0.255345 34.986 0.277555L95.1735 22.5693C96.9227 23.2171 98.0837 24.885 98.0837 26.7501V71.3334C98.0837 73.7961 96.0877 75.7921 93.625 75.7921H4.45834C1.99607 75.7921 0 73.7961 0 71.3334V26.7501C0 25.3659 0.64291 24.0603 1.74004 23.2163L30.7192 0.924656ZM57.9584 66.8751H69.1042V47.7968L57.9584 44.0816V66.8751ZM78.0209 66.8751V44.5834C78.0209 42.6644 76.7929 40.9607 74.9724 40.3539L54.9099 33.6664C53.5503 33.2132 52.0558 33.4412 50.8932 34.2792C49.7306 35.1171 49.0417 36.4628 49.0417 37.8959V66.8751H37.8959V10.864L89.1667 29.8532V66.8751H78.0209ZM28.9792 13.5127V66.8751H8.91667V28.9454L28.9792 13.5127Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/CompanyIcon.3ef9ba5d0fe24b11aeaa914c6c391deb.svg";
export { ForwardRef as ReactComponent };